// @flow
import React from 'react';
import type { Node } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiDrawer from '@material-ui/core/Drawer';

const drawerWidth = 300;

const styles = {
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        zIndex: 1,
    },
    layout: {
        paddingTop: 136,
    }
};

type Props = {
    classes: {
        drawer: string,
        drawerPaper: string,
        layout: string,
    },
    open: boolean,
    children: Node,
};

const Drawer = (props: Props) => (
    <MuiDrawer
        className={props.classes.drawer}
        classes={{
            paper: props.classes.drawerPaper,
        }}
        variant="persistent"
        anchor="right"
        open={props.open}
    >
        <div className={props.classes.layout}>
            {props.children}
        </div>

    </MuiDrawer>

);

Drawer.defaultProps = {
    open: false,
};

export default withStyles(styles)(Drawer);
